export default function ({ route, redirect }) {
  // Normalize the route path by removing the trailing slash (except if it's just '/')
  let normalizedPath = route.path;
  if (normalizedPath.length > 1 && normalizedPath.endsWith('/')) {
    normalizedPath = normalizedPath.slice(0, -1);
  }

  // Define your custom redirect rules.
  // Each rule uses a regex (that accepts an optional trailing slash) and a replacement.
  const redirects = [
    {
      // For review URLs: e.g. /review/abc or /review/abc/ → /studio/edit/abc
      from: /^\/review\/(.+?)\/?$/,
      to: "/studio/edit/$1"
    },
    {
      // For curriculums: e.g. /curriculums or /curriculums/ → /lessons
      from: /^\/curriculums\/?$/,
      to: "/lessons"
    },
    {
      // For stories:
      // This rule matches:
      //   - "/stories" or "/stories/" 
      //   - "/stories/slug" or "/stories/slug/"
      // and always redirects to the /projects version (without a trailing slash)
      from: /^\/stories(\/.*)?\/?$/,
      to: "/projects$1"
    },
  ];

  // Check if one of the rules applies.
  let newLocation = normalizedPath;
  let ruleFound = false;
  for (const rule of redirects) {
    if (rule.from.test(normalizedPath)) {
      newLocation = normalizedPath.replace(rule.from, rule.to);
      ruleFound = true;
      break;
    }
  }

  // Ensure the new location does NOT have a trailing slash (unless it is the root '/').
  if (newLocation !== '/' && newLocation.endsWith('/')) {
    newLocation = newLocation.slice(0, -1);
  }

  // If a rule was matched and the new location differs from the normalized path, redirect.
  if (ruleFound && newLocation !== normalizedPath) {
    return redirect(301, newLocation);
  }

  // Global catch: if no custom rule was triggered but the route originally ended with a slash,
  // redirect to the version without a trailing slash.
  if (!ruleFound && route.path.length > 1 && route.path.endsWith('/')) {
    return redirect(301, normalizedPath);
  }
}
